// 不保存session
const state = {
  imgUrl:'',
  applyInfo:{}
}

const mutations = {
  setUserKey(state, { key, value }) {
    state[key] = value
  }
}

const actions = {

}

const getters = {
  imgUrl: state => state.imgUrl,
  applyInfo: state => state.applyInfo
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
